import { createContext } from "react";

const TypeMasterContext = createContext({});

export default TypeMasterContext;
